import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'ordenPro',
})
export class OrdenProPipe implements PipeTransform {

  transform(items: any[], filter: any[]): any {

    if(filter['activo']) {


      if (filter['dir'] == 'ASC') {

        return items.sort((a, b) => a[filter['campo']] - b[filter['campo']]);

      } else if (filter['dir'] == 'DESC') {

        return items.sort((a, b) => b[filter['campo']] - a[filter['campo']]);
      }
    }else {

      return  items;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pipes/orden-pro/orden-pro.ts